export class EmailAddress {
  id: number;
  email: string;
  notes: string;
  position: number;
  contact_id: number;
  editing: boolean = false;
  deleting: boolean = false;
}
